/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import { Row, Col, Form, Spin, message, Carousel, Tooltip } from "antd";

import PropTypes from "prop-types";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

import { shallowEqual, useSelector, useDispatch } from "react-redux";

import "./index.scss";
import accountBookingArrowIcon from "../../assests/images/arrow.svg";
import calenderIcon from "../../assests/images/calenderIcon.svg";

import DashbordCard from "./DashbordCard";
import constant from "../../constants/constants";
import { getAccountService } from "../../actionsMethods/cashBookingMethods";
import API from "../../api";
import { ReloadOutlined } from "@ant-design/icons";
import moment from "moment";
import nodeURLs from "../../api/nodeUrls";
import { capitalize } from "../../utils";
import delivery_partner from "../../assests/images/SVG/DeliveryPartner.svg";
import hubs from "../../assests/images/SVG/Hubs.svg";
import pincodes from "../../assests/images/SVG/Pincodes.svg";

const { ROLES } = constant;
const { CENTRALOPS_ADMIN, MIS_EXECUTIVE } = ROLES;

const { SHIPMENT_COUNT } = nodeURLs;

let getAllPincodes = JSON.parse(localStorage.getItem("allPincodes")) || null;

function EcommOnboarding() {
  const dispatch = useDispatch();

  const userinfo = JSON.parse(localStorage.getItem("userinfo"));
  const getRole = userinfo?.roles[0]?.replace(/.*_/, "");
  const dashboardMenuList = [
    {
      icon: hubs,
      title: "Hubs",
      id: "hubs",
      additionalClass: "",
      route: "/hubs?type=ECOMM",
      role: [CENTRALOPS_ADMIN, MIS_EXECUTIVE],
    },
    {
      icon: delivery_partner,
      title: "Delivery Partner",
      id: "delivery-partner",
      additionalClass: "",
      route: "/delivery-partner?type=ECOMM",
      role: [CENTRALOPS_ADMIN, MIS_EXECUTIVE],
    },
    {
      icon: pincodes,
      title: "DP - Pincode",
      id: "dp-pincode",
      additionalClass: "",
      route: "/dp-pincode?type=ECOMM",
      role: [CENTRALOPS_ADMIN, MIS_EXECUTIVE],
    },
  ];

  const [form] = Form.useForm();

  const [accountDetails, setAccountDetails] = useState();
  const [day, setDay] = useState(1);
  const [onClickTime, setOnClickTime] = useState("");
  const [loading, setLoading] = useState(false);
  const [todayData, setTodayData] = useState([]);

  const styleObj = {
    inscanned: {
      styles: {
        backgroundColor: "#FFD3D1",
        border: "1px solid #FFD5D3",
      },
      textColor: { color: "#E65B6B" },
    },
    outscan: {
      styles: {
        backgroundColor: "#27AE6014",
        border: "1px solid #8CE7B3",
      },
      textColor: { color: "#107A59" },
    },
    expected: {
      styles: {
        backgroundColor: "#fff7d9",
        border: "1px solid #ffe9bb",
      },
      textColo: { color: "#c59f0c" },
    },
    pending: {
      styles: {
        backgroundColor: "#fff7d9",
        border: "1px solid #ffe9bb",
      },
      textColor: { color: "#c59f0c" },
    },
    defalut: {
      styles: {
        backgroundColor: "#fff7d9",
        border: "1px solid #ffe9bb",
      },
      textColo: { color: "#c59f0c" },
    },
  };

  const getpremiseResponse = useSelector(
    (state) => state?.appReducer?.getCpPremiseReducer,
    shallowEqual,
  );

  const { fetching, result } = getpremiseResponse;

  useEffect(() => {
    if (!fetching) {
      localStorage.setItem(
        "permises",
        JSON.stringify(result, getpremiseResponse?.result?.premises?.stateCode),
      );
    }
  }, [getpremiseResponse]);

  useEffect(() => {
    setAccountDetails(JSON.parse(localStorage.getItem("userinfo")));
  }, []);

  useEffect(() => {
    if (accountDetails !== undefined) {
      dispatch(getAccountService(accountDetails?.username));
    }
  }, [accountDetails]);

  const getTodaysData = async (date = null) => {
    setLoading(true);
    const param = {
      date,
    };

    const response = await API.Api(`${SHIPMENT_COUNT}`).NodeGetWithPremise(
      date && param,
    );

    if (response?.status) {
      setLoading(false);
      let data = response?.response?.data;
      const order = ["expected", "inscanned", "outscan", "pending"];
      data?.sort(
        (a, b) => order?.indexOf(a?.status) - order?.indexOf(b?.status),
      );
      setOnClickTime(moment().format("hh:mm a"));
      setTodayData(data);
    } else {
      setLoading(false);
      setTodayData([]);

      message.error(response?.statusText || "Internal server error");
    }

    setLoading(false);
  };

  // For Pincodes suggesstion
  const getAllPincodesForSuggestions = async () => {
    setLoading(true);
    let res = await API.Api(
      "https://bookingapis.innofulfill.com/pincode",
    ).get();
    if (res?.status) {
      setLoading(false);
      const response = res?.response?.data;
      localStorage.setItem(
        "allPincodes",
        JSON.stringify(
          response?.map((item) => ({
            Pincode: item.Pincode,
            StateName: item.StateName,
            CityName: item.CityName,
          })),
        ) || null,
      );
    } else {
      setLoading(false);
      localStorage.setItem("allPincodes", null);

      message.error("Pincodes fetch error");
    }
  };

  useEffect(() => {
    if (getAllPincodes == null) {
      getAllPincodesForSuggestions();
    }
  }, [getAllPincodes]);

  const SampleNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          color: "black",
          fontSize: "15px",
          lineHeight: "1.5715 ",
        }}
        onClick={onClick}
      >
        <RightOutlined />
      </div>
    );
  };

  const SamplePrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          color: "black",
          fontSize: "15px",
          lineHeight: "1.5715 ",
        }}
        onClick={onClick}
      >
        <LeftOutlined />
      </div>
    );
  };

  const settings = {
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const handleAfterChange = (current) => {
    setDay(current);
    if (current) {
      getTodaysData();
    } else {
      getTodaysData(moment().subtract(1, "days").format("YYYY-MM-DD"));
    }
  };

  return (
    <div className="dashboard-container">
      <Spin spinning={fetching || loading}>
        <Form form={form} layout="vertical" autoComplete="off">
          <div className="dashboardHeading">Ecomm Onboarding</div>

          <Row gutter={[32, 32]} className="dashboard-container-row">
            <Col
              className="dashboard-container-col"
              xl={16}
              lg={16}
              md={24}
              sm={24}
              xs={24}
            >
              {getRole === "HUBADMIN" && (
                <Spin spinning={todayData === null}>
                  <Row>
                    <Col
                      xl={24}
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      className="dashboard-container-col-innercol"
                    >
                      <div className="dashboard-container-col-innercol-trackOrder">
                        <span
                          style={{ color: "green", fontSize: "13px" }}
                          className="dashboard-container-col-innercol-trackOrder-name"
                        >
                          Shipment Status
                        </span>
                        <div style={{ color: "red", fontSize: "13px" }}>
                          Results as on
                          {day ? `${onClickTime} Today` : "Yesterday"}
                          {day ? (
                            <Tooltip title={"Reload"}>
                              <ReloadOutlined
                                onClick={() => getTodaysData()}
                                style={{
                                  fontSize: 18,
                                  paddingLeft: "10px",
                                  color: "black",
                                }}
                              />
                            </Tooltip>
                          ) : null}
                        </div>
                      </div>

                      <div className="custom-carousel">
                        <Carousel
                          {...settings}
                          infinite={false}
                          afterChange={handleAfterChange}
                          initialSlide={1}
                        >
                          <Spin spinning={loading}>
                            <div>
                              {todayData.length > 0 && (
                                <ShipmentStatusCompo
                                  array={todayData}
                                  styleObj={styleObj}
                                />
                              )}
                            </div>
                          </Spin>
                          <Spin spinning={loading}>
                            <div>
                              {todayData.length > 0 && (
                                <ShipmentStatusCompo
                                  array={todayData}
                                  styleObj={styleObj}
                                />
                              )}
                            </div>
                          </Spin>
                        </Carousel>
                      </div>
                    </Col>
                  </Row>
                </Spin>
              )}
              <Row gutter={[32, 32]}>
                {dashboardMenuList?.map((item, index) => {
                  if (
                    item?.role === "" ||
                    item.role.some((e) => accountDetails?.roles?.includes(e))
                  ) {
                    return (
                      <Col
                        xl={6}
                        lg={8}
                        md={10}
                        sm={12}
                        xs={12}
                        className="cash-booking"
                        key={index}
                      >
                        <DashbordCard
                          accountBookingArrowIcon={accountBookingArrowIcon}
                          accountBookingIcon={item.icon}
                          watchIcon={calenderIcon}
                          bookingType={item.title}
                          route={item.onClick ? undefined : item.route}
                          id="cashBooking"
                          stateId={item.stateId}
                          onClick={item.onClick}
                        />
                      </Col>
                    );
                  }
                })}
              </Row>
            </Col>
          </Row>
        </Form>
      </Spin>
    </div>
  );
}
EcommOnboarding.propTypes = {
  data1: PropTypes.number,
};

export default EcommOnboarding;

const ShipmentStatusCompo = ({ array, styleObj }) => (
  <Row gutter={12} className="p-1">
    {array?.map((item, i) => (
      <Col lg={6} md={6} sm={6} key={i}>
        <div
          className="shipmentStatusContainer"
          style={styleObj[item?.status]?.styles}
        >
          <div className="textNumber" style={styleObj[item?.status]?.textColor}>
            {item?.total_count}
          </div>
          <div>{capitalize(item?.status)}</div>
        </div>
      </Col>
    ))}
  </Row>
);
